// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36kdB","colBig":"styles_colBig__2C5Fu","colSmall":"styles_colSmall__br2R_"};